export const SERVER_CONTEXT_PATH = (window as any).appConfig.serverContextPath;
export const OVERLAY_LAYER_ID = '__overlay__';
